export default "__VITE_ASSET__CeH8gXxQ__"